import { render, staticRenderFns } from "./CopywritingTemplateModal.vue?vue&type=template&id=bc9b9004&scoped=true"
import script from "./CopywritingTemplateModal.vue?vue&type=script&lang=js"
export * from "./CopywritingTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CopywritingTemplateModal.vue?vue&type=style&index=0&id=bc9b9004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9b9004",
  null
  
)

export default component.exports